// extracted by mini-css-extract-plugin
module.exports = {"history":"TransactionsHistory_history__2ZXtD"};